import { useEffect, useRef, useState } from "react";

// Lightweight scroll-reveal wrapper (replaces framer-motion whileInView).
// IntersectionObserver effect returns a real cleanup function (React 19 safe).
export function Reveal({ as: Tag = "div", delay = 0, className = "", children, ...rest }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShown(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      style={{ animationDelay: `${delay}s` }}
      className={`${shown ? "rs-reveal" : "opacity-0"} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
